// Centralized propType definitions
import PropTypes from 'prop-types';

const { arrayOf, shape, number, bool, string, float } = PropTypes;

export const product = shape({
  id: number,
  name: string,
  qty: number,
  price: number,
  subtotal: number,
  trackingNumber: arrayOf(string),
  trackingType: arrayOf(string),
  image: string,
  specialShipDate: number,
  backorderShipDate: number,
});

export const order = shape({
  id: number,
  catId: number,
  orderNumber: number,
  total: number,
  status: string,
  shipTo: string,
  orderDate: string,
  products: arrayOf(product),
  isInvoiceAvailable: bool,
});

export const quote = shape({
  id: number,
  catId: number,
  total: number,
  shipTo: string,
  orderDate: string,
  products: arrayOf(product),
});

export const printer = shape({
  id: number,
  catId: number,
  name: string,
  image: string,
  isNew: false,
  brandName: string
});
